import { TextField } from '@mui/material'
import { useAppSelector } from '~/app/hooks'
import { currentTheme } from '~/redux/features'
import { camalize } from '~/utils'
import { EFInputLabel } from '../EFInputLabel'
import { EFTextFieldProps } from './EFTextField.model'
import { EFTypography } from '../EFTypography'
import classNames from 'classnames/bind'
import styles from './EFTextField.module.scss'

const cx = classNames.bind(styles)

export function CustomTextField(props: EFTextFieldProps) {
  const theme = useAppSelector(currentTheme)
  const {validateFn, blurFn, ...baseProps} = props; //Some of these props shouldnt be passed down
  return (
    <div className='custom-field'>
      {props.label && (
        <EFInputLabel
          label={props.label}
          name={props.name}
          sx={props.labelSx}
        >
          <EFTypography fontSize='0.8rem !important'>{props.description}</EFTypography>
        </EFInputLabel>
      )}

      <TextField
        {...baseProps}
        sx={{
          ...props.sx
        }}
        autoComplete='new-password'
        type={props.type}
        name={props.name}
        value={props.value ?? ''}
        placeholder={props.placeholder}
        id={camalize(props.name)}
        InputLabelProps={{ sx: { display: 'none' }, shrink: false }}
        className={cx('text-field', theme)}
      />
    </div>
  )
}
